import { create_api } from './base';

export default class DropoffLocationsHistoryRepo {
  constructor() {
    this.api = create_api(import.meta.env.REACT_APP_API_ROOT);
  }

  get = (params) => this.api.get(`/dropoff-location-history`, params);
}
